<template>
  <app-content class="app-home-vue frame-page">
    <template v-if="currentAccountSets">
      <Row :space="16">
        <Cell :width="16">
          <!--常用功能-->
          <div class="h-panel home-panel">
            <div class="h-panel-bar">
              <span class="h-panel-title">常用功能</span>
              <div class="h-panel-right">
                <i v-tooltip content="参数中心" class="fa fa-cog gray-color text-hover" @click="go('SetsSettings')"></i>
              </div>
            </div>
            <div class="h-panel-body quick-entry">
              <div class="quick-item" v-for="item in quickEntries" :key="item.name" @click="go(item.name)">
                <i :class="item.icon"></i>
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>

          <Row :space="16">
            <Cell :width="12">
              <!--本期凭证-->
              <div class="h-panel home-panel vouch-panel">
                <div class="h-panel-bar">
                  <span class="h-panel-title">本期凭证<small class="gray-color">（{{ periodText }}，共{{ voucherCount }}张）</small></span>
                  <div class="h-panel-right"><a class="panel-link" @click="go('Voucher')">查看凭证 &gt;</a></div>
                </div>
                <div class="h-panel-body vouch-add" @click="addVouch">
                  <div class="vouch-add-icon"><i class="fa fa-plus"></i></div>
                  <p>新增凭证</p>
                </div>
              </div>
            </Cell>
            <Cell :width="12">
              <!--企业票夹-->
              <div class="h-panel home-panel">
                <div class="h-panel-bar">
                  <span class="h-panel-title">企业票夹<small class="gray-color">（{{ periodText }}）</small></span>
                  <div class="h-panel-right"><a class="panel-link" @click="go('InputInvoice')">采集发票 &gt;</a></div>
                </div>
                <div class="h-panel-body invoice-body">
                  <div class="invoice-block" v-for="row in invoiceRows" :key="row.key" @click="go(row.route)">
                    <div class="invoice-label"><i class="invoice-dot" :class="row.dotClass"></i>{{ row.name }}</div>
                    <div class="invoice-amount">¥ {{ fmt(row.amount) }}</div>
                    <div class="invoice-sub">价税合计 · {{ row.count }}张</div>
                    <div class="invoice-sub">税额 ¥ {{ fmt(row.tax) }}</div>
                  </div>
                  <div v-if="invoiceEmpty" class="invoice-empty">当期未采集</div>
                </div>
              </div>
            </Cell>
          </Row>

          <!--财务指标-->
          <div class="h-panel home-panel">
            <div class="h-panel-bar">
              <span class="h-panel-title">财务指标</span>
              <div class="h-panel-right">
                <i v-tooltip content="科目余额表" class="fa fa-cog gray-color text-hover" @click="go('SubjectBalance')"></i>
              </div>
            </div>
            <div class="h-panel-body">
              <Row :space="12">
                <Cell :width="8" v-for="item in metrics" :key="item.code">
                  <div class="metric-item">
                    <div class="metric-value" v-tooltip :content="fmt(item.value)">¥ {{ fmt(item.value) }}</div>
                    <div class="metric-name">{{ item.name }}</div>
                  </div>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>

        <Cell :width="8">
          <!--资讯通知-->
          <div class="h-panel home-panel notice-panel">
            <div class="h-panel-bar">
              <span class="h-panel-title">资讯通知</span>
              <div class="h-panel-right"><a class="panel-link" @click="openNoticeModal">更多 &gt;</a></div>
            </div>
            <div class="h-panel-body side-list">
              <div class="notice-item" v-for="notice in notices" :key="notice.id" @click="viewNotice(notice)">
                <span class="notice-title">{{ notice.title }}</span>
                <span class="notice-date">{{ formatDate(notice.publishDate) }}</span>
              </div>
              <div v-if="!notices.length" class="empty-tip">暂无通知</div>
            </div>
          </div>

          <!--备忘录-->
          <div class="h-panel home-panel memo-panel">
            <div class="h-panel-bar">
              <span class="h-panel-title">备忘录</span>
              <div class="h-panel-right">
                <a class="panel-link" @click="openMemoModal">更多 &gt;</a>
              </div>
            </div>
            <div class="h-panel-body side-list">
              <div class="memo-item" v-for="memo in memos" :key="memo.id" @click="openMemoModal">
                <div class="memo-text">{{ memo.content }}</div>
                <div class="memo-date">{{ formatDate(memo.updateDate) }}</div>
              </div>
              <div v-if="!memos.length" class="empty-tip">暂无备忘</div>
            </div>
          </div>
        </Cell>
      </Row>

      <!--原有：货币资金 / 费用统计 / 收入利润图-->
      <Row :space="24" class="margin-top">
        <Cell :width="8">
          <div class="h-panel" style="height: 235px">
            <div class="h-panel-bar">
              <div class="h-panel-title">货币资金</div>
              <div class="h-panel-right"><span class="gray-color">总资金</span><i class="h-split"></i><span v-tooltip :content="cashTotal" class="font20 primary-color text-hover">{{ cashTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>
            </div>
            <div class="h-panel-body">
              <Row style="line-height: 45px;" type="flex" v-for="cash in cashData" :key="cash.name">
                <Cell :flex="1">{{ cash.name }}</Cell>
                <Cell><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell :width="8">
          <div class="h-panel" style="height: 235px">
            <div class="h-panel-bar">
              <div class="h-panel-title">费用统计</div>
              <div class="h-panel-right"><span class="gray-color">总费用</span><i class="h-split"></i><span v-tooltip :content="costTotal" class="font20 primary-color text-hover">{{ costTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>
            </div>
            <div class="h-panel-body">
              <Row style="line-height: 45px;" type="flex" v-for="cash in costData" :key="cash.name">
                <Cell :flex="1">{{ cash.name }}</Cell>
                <Cell><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell :width="24">
          <div class="h-panel">
            <div class="h-panel-body home-part-body2">
              <Row :space="20">
                <Cell :width="24">
                  <Chart :options="revenueProfitOptions"></Chart>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>
      </Row>
    </template>
    <div class="h-panel" v-else>
      <div class="h-panel-bar"><span class="h-panel-title">初始化账套</span></div>
      <div class="h-panel-body">
        <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
          <FormItem label="单位名称:" prop="companyName">
            <input type="text" v-model="form.companyName">
          </FormItem>
          <FormItem label="账套启用年月:" prop="enableDate">
            <DatePicker type="month" v-model="form.enableDate"/>
          </FormItem>
          <FormItem label="统一社会信用代码:">
            <input type="text" v-model="form.creditCode">
          </FormItem>
          <FormItem label="会计准则:" prop="accountingStandards" single>
            <Select v-model="form.accountingStandards" dict="accountingStandards" :nullOption="false"></Select>
            <p class="h-text-help" style="margin-top:5px;">创建后将按所选会计准则自动初始化会计科目及资产负债表、利润表、现金流量表</p>
          </FormItem>
          <FormItem label="单位所在地:">
            <CategoryPicker ref="CategoryPicker" :option="pickerOption" type="key" showAllLevels v-model="form.address"></CategoryPicker>
          </FormItem>
          <FormItem label="行业:">
            <Select v-model="form.industry" dict="industry"></Select>
          </FormItem>
          <FormItem label="增值税种类:" prop="vatType">
            <Radio v-model="form.vatType" dict="vatRadios"></Radio>
          </FormItem>
          <FormItem label="凭证是否需要审核:" prop="voucherReviewed">
            <Radio v-model="form.voucherReviewed" dict="needRadios"></Radio>
          </FormItem>
          <FormItem single>
            <Button color="green" @click="submit" :loading="loading">创建账套</Button>
          </FormItem>
        </Form>
      </div>
    </div>

    <!--资讯通知-->
    <Modal v-model="noticeVisible" hasCloseIcon hasDivider :closeOnMask="false" :width="600">
      <div slot="header">资讯通知</div>
      <div class="notice-modal-list">
        <div class="notice-modal-item" v-for="notice in noticeList" :key="notice.id">
          <div class="notice-modal-title" @click="toggleNotice(notice)">
            <span class="notice-title">{{ notice.title }}</span>
            <span class="notice-date">{{ formatDate(notice.publishDate) }}</span>
          </div>
          <div class="notice-modal-content" v-if="expandedNoticeId === notice.id">
            <span v-if="notice.type" class="h-tag h-tag-blue">{{ notice.type }}</span>
            <p>{{ notice.content || '暂无详细内容' }}</p>
          </div>
        </div>
        <div v-if="!noticeList.length" class="empty-tip">暂无通知</div>
      </div>
      <div slot="footer">
        <Button @click="noticeVisible=false">关闭</Button>
      </div>
    </Modal>

    <!--备忘录-->
    <Modal v-model="memoVisible" hasCloseIcon hasDivider :closeOnMask="false" :width="520">
      <div slot="header">备忘录</div>
      <div class="memo-editor">
        <textarea v-model="memoForm.content" rows="3" maxlength="500" placeholder="记录一条备忘..."></textarea>
        <div class="memo-editor-bar">
          <span class="gray-color">{{ (memoForm.content || '').length }}/500</span>
          <div>
            <Button size="s" v-if="memoForm.id" @click="resetMemoForm">取消编辑</Button>
            <Button size="s" color="primary" :loading="memoSaving" @click="saveMemo">{{ memoForm.id ? '保存修改' : '添加备忘' }}</Button>
          </div>
        </div>
      </div>
      <div class="memo-list">
        <div class="memo-list-item" v-for="memo in memoList" :key="memo.id">
          <div class="memo-text">{{ memo.content }}</div>
          <div class="memo-item-bar">
            <span class="gray-color">{{ formatDateTime(memo.updateDate) }}</span>
            <span>
              <a class="panel-link" @click="editMemo(memo)">编辑</a>
              <a class="red-color memo-delete" @click="removeMemo(memo)">删除</a>
            </span>
          </div>
        </div>
        <div v-if="!memoList.length" class="empty-tip">暂无备忘</div>
      </div>
      <div slot="footer">
        <Button @click="memoVisible=false">关闭</Button>
      </div>
    </Modal>
  </app-content>
</template>
<script>
import revenueProfit from '../js/data/revenueProfit';
import {getTotalData} from '../js/locations/district';
import {mapState} from 'vuex';
import moment from "moment";

const emptyForm = {
  "accountingStandards": "0",
  "address": null,
  "companyName": "",
  "creditCode": "",
  "enableDate": null,
  "fixedAssetModule": "0",
  "cashierModule": "0",
  "voucherReviewed": "0",
  "industry": "",
  "vatType": "0"
};

const emptyInvoiceStat = {
  outAmount: 0,
  outCount: 0,
  outTaxAmount: 0,
  inAmount: 0,
  inCount: 0,
  inTaxAmount: 0
};

export default {
  name: 'Home',
  data() {
    return {
      revenueProfitOptions: revenueProfit,
      cashData: [{name: '库存现金', value: 0}, {name: '银行存款', value: 0}, {name: '其他货币资金', value: 0}],
      costData: [{name: '销售费用', value: 0}, {name: '管理费用', value: 0}, {name: '财务费用', value: 0}],
      voucherCount: 0,
      invoiceStat: Object.assign({}, emptyInvoiceStat),
      metrics: [
        {code: '1122', name: '应收账款', value: 0},
        {code: '2202', name: '应付账款', value: 0},
        {code: '1002', name: '银行存款', value: 0},
        {code: '1001', name: '库存现金', value: 0},
        {code: '1601', name: '固定资产', value: 0}
      ],
      quickEntries: [
        {name: 'DetailedAccounts', title: '明细账', icon: 'fa fa-book'},
        {name: 'Voucher', title: '凭证列表', icon: 'fa fa-file-text-o'},
        {name: 'SubjectBalance', title: '科目余额表', icon: 'fa fa-balance-scale'}
      ],
      notices: [],
      noticeList: [],
      noticeVisible: false,
      expandedNoticeId: null,
      memos: [],
      memoList: [],
      memoVisible: false,
      memoSaving: false,
      memoForm: {id: null, content: ''},
      loading: false,
      datas: [],
      type: 'type1',
      pickerOption: {
        keyName: 'id',
        titleName: 'title',
        dataMode: 'list',
        parentName: 'parentId',
        datas: getTotalData()
      },
      form: Object.assign({}, emptyForm),
      validationRules: {
        // 注意：required 中的键必须与 form 模型字段一致，且表单需存在对应 FormItem，
        // 否则校验永远不通过且错误无法展示（历史遗留 fixed_asset_module / cashier_module 已移除）
        required: ["companyName", "enableDate", "accountingStandards", "voucherReviewed", "vatType"]
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets']),
    //统计期间以账套当前记账年月为准
    periodText() {
      const date = this.currentAccountSets && this.currentAccountSets.currentAccountDate;
      return (date ? moment(date) : moment()).format('YYYY-MM') + '期';
    },
    invoiceRows() {
      return [
        {
          key: 'out',
          name: '销项',
          route: 'OutputInvoice',
          dotClass: 'dot-out',
          amount: this.invoiceStat.outAmount,
          count: this.invoiceStat.outCount,
          tax: this.invoiceStat.outTaxAmount
        },
        {
          key: 'in',
          name: '进项',
          route: 'InputInvoice',
          dotClass: 'dot-in',
          amount: this.invoiceStat.inAmount,
          count: this.invoiceStat.inCount,
          tax: this.invoiceStat.inTaxAmount
        }
      ];
    },
    //当期未采集：销项、进项均无发票时提示
    invoiceEmpty() {
      return (Number(this.invoiceStat.outCount) || 0) + (Number(this.invoiceStat.inCount) || 0) === 0;
    },
    costTotal() {
      let total = 0;
      this.costData.forEach(item => {
        total += item.value;
      });
      return total.toFixed(2);
    },
    cashTotal() {
      let total = 0;
      this.cashData.forEach(item => {
        total += item.value;
      });
      return total.toFixed(2);
    }
  },
  methods: {
    go(name) {
      this.$router.push({name});
    },
    addVouch() {
      this.$router.push({name: 'VoucherForm'});
    },
    fmt(value) {
      return (Number(value) || 0).toFixed(2);
    },
    formatDate(value) {
      return value ? moment(value).format('YYYY.MM.DD') : '';
    },
    formatDateTime(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm') : '';
    },
    periodRange() {
      const date = this.currentAccountSets && this.currentAccountSets.currentAccountDate
        ? moment(this.currentAccountSets.currentAccountDate) : moment();
      return {
        start: date.clone().startOf('month').format('YYYY-MM-DD'),
        end: date.clone().endOf('month').format('YYYY-MM-DD')
      };
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
        this.$api.setting.accountSets[this.form.id ? 'update' : 'save'](this.form).then(() => {
          this.loading = false;
          window.location.reload();
        }).catch(() => {
          this.loading = false;
        })
      }
    },
    init() {
      this.loadNotices();
      this.loadMemos();
      //未选择账套或未设置启用年月时不请求账套相关统计，避免后台反复提示
      if (!this.currentAccountSets || !this.currentAccountSets.currentAccountDate) {
        return;
      }
      const range = this.periodRange();
      //单个接口失败不影响其它模块展示
      const safe = (request, fallback) => request.catch(() => ({data: fallback}));
      Promise.all([
        safe(this.$api.home.voucherCount(), 0),
        safe(this.$api.home.financialMetrics(), []),
        safe(this.$api.invoice.invoice.summary({
          start: range.start,
          end: range.end,
          excludeStatus: 'VOID,RED_ALL'
        }), {}),
        safe(this.$api.home.chart.revenueProfit(), {}),
        safe(this.$api.home.chart.cost(), []),
        safe(this.$api.home.chart.cash(), [])
      ]).then(([voucher, metrics, invoice, revenue, cost, cash]) => {
        this.voucherCount = Number(voucher.data) || 0;
        this.mergeMetrics(metrics.data);
        this.applyInvoiceStat(invoice.data);
        this.updateRevenueProfitOptions(revenue.data);
        this.cashData = this.mergeStatRows(cash.data, this.cashData);
        this.costData = this.mergeStatRows(cost.data, this.costData);
      });
    },
    applyInvoiceStat(stat) {
      stat = stat || {};
      this.invoiceStat = {
        outAmount: Number(stat.outAmount) || 0,
        outCount: Number(stat.outCount) || 0,
        outTaxAmount: Number(stat.outTaxAmount) || 0,
        inAmount: Number(stat.inAmount) || 0,
        inCount: Number(stat.inCount) || 0,
        inTaxAmount: Number(stat.inTaxAmount) || 0
      };
    },
    //财务指标按科目编码合并，缺失补 0，保证指标格子顺序与位置固定
    mergeMetrics(rows) {
      const valueMap = {};
      (rows || []).forEach(row => {
        if (row && row.code) {
          valueMap[row.code] = Number(row.value) || 0;
        }
      });
      this.metrics = this.metrics.map(item => Object.assign({}, item, {
        value: Object.prototype.hasOwnProperty.call(valueMap, item.code) ? valueMap[item.code] : 0
      }));
    },
    loadNotices() {
      this.$api.common.latestAnnouncements(5).then(({data}) => {
        this.notices = data || [];
      }).catch(() => {
        this.notices = [];
      });
    },
    loadAllNotices() {
      this.$api.common.latestAnnouncements(50).then(({data}) => {
        this.noticeList = data || [];
      }).catch(() => {
        this.noticeList = [];
      });
    },
    openNoticeModal() {
      this.expandedNoticeId = null;
      this.noticeVisible = true;
      this.loadAllNotices();
    },
    viewNotice(notice) {
      this.expandedNoticeId = notice.id;
      this.noticeVisible = true;
      this.loadAllNotices();
      //标记已读，避免登录后的公告弹窗重复提醒
      this.$api.common.markAnnouncementRead({id: notice.id}).catch(() => {
      });
    },
    toggleNotice(notice) {
      this.expandedNoticeId = this.expandedNoticeId === notice.id ? null : notice.id;
    },
    loadMemos() {
      this.$api.memo.list(5).then(({data}) => {
        this.memos = data || [];
      }).catch(() => {
        this.memos = [];
      });
    },
    loadAllMemos() {
      this.$api.memo.list(100).then(({data}) => {
        this.memoList = data || [];
        this.memos = this.memoList.slice(0, 5);
      }).catch(() => {
        this.memoList = [];
      });
    },
    openMemoModal() {
      this.resetMemoForm();
      this.memoVisible = true;
      this.loadAllMemos();
    },
    resetMemoForm() {
      this.memoForm = {id: null, content: ''};
    },
    editMemo(memo) {
      this.memoForm = {id: memo.id, content: memo.content};
    },
    saveMemo() {
      const content = (this.memoForm.content || '').trim();
      if (!content) {
        this.$Message.error('备忘内容不能为空！');
        return;
      }
      this.memoSaving = true;
      let request = this.memoForm.id
        ? this.$api.memo.update(this.memoForm.id, content)
        : this.$api.memo.save(content);
      request.then(() => {
        this.$Message.success('保存成功~');
        this.resetMemoForm();
        this.loadAllMemos();
        this.loadMemos();
      }).catch(() => {
      }).finally(() => {
        this.memoSaving = false;
      });
    },
    removeMemo(memo) {
      this.$Confirm('确认删除该条备忘?').then(() => {
        this.$api.memo.remove(memo.id).then(() => {
          this.$Message.success('删除成功~');
          if (this.memoForm.id === memo.id) {
            this.resetMemoForm();
          }
          this.loadAllMemos();
          this.loadMemos();
        });
      }).catch(() => {
      });
    },
    /**
     * 用接口数据填充固定展示行：保持库存现金/银行存款/其他货币资金等默认顺序，
     * 缺失项补 0，接口新增的类型追加在末尾，避免返回顺序变化导致首页卡片跳动
     */
    mergeStatRows(rows, defaults) {
      const valueMap = {};
      (rows || []).forEach(row => {
        if (row && row.name) {
          valueMap[row.name] = Number(row.value) || 0;
        }
      });
      const result = defaults.map(item => Object.assign({}, item, {
        value: Object.prototype.hasOwnProperty.call(valueMap, item.name) ? valueMap[item.name] : 0
      }));
      Object.keys(valueMap).forEach(name => {
        if (!result.some(item => item.name === name)) {
          result.push({name, value: valueMap[name]});
        }
      });
      return result;
    },
    updateRevenueProfitOptions(chartData) {
      chartData = chartData || {};
      let lr = chartData["本年利润"];
      let zysr = chartData["主营业务收入"];
      let opt = Object.assign({}, this.revenueProfitOptions);
      // 深拷贝 series 并重置为 12 个月 0 值，避免污染模块级配置及切换账套时残留上期数据
      opt.series = this.revenueProfitOptions.series.map(s => Object.assign({}, s, {data: new Array(12).fill(0)}));
      if (lr) {
        Object.keys(lr).forEach(value => {
          opt.series[1].data[value - 1] = (lr[value] / 1000).toFixed(2);
        });
      }
      if (zysr) {
        Object.keys(zysr).forEach(value => {
          opt.series[0].data[value - 1] = (zysr[value] / 1000).toFixed(2);
        });
      }
      this.revenueProfitOptions = opt;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less" scoped>
  .app-home-vue {
    .home-panel {
      margin-bottom: 16px;
    }

    .panel-link {
      color: @primary-color;
      cursor: pointer;
    }

    .quick-entry {
      display: flex;
      flex-wrap: wrap;
      padding: 12px 16px;
    }

    .quick-item {
      width: 96px;
      height: 58px;
      margin-right: 12px;
      border-radius: 4px;
      background: #f7f9fc;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #515a6e;
      transition: all .2s;

      i {
        font-size: 17px;
        color: @primary-color;
        margin-bottom: 6px;
      }

      &:hover {
        background: #eef4ff;
        color: @primary-color;
      }
    }

    .vouch-panel {
      min-height: 200px;
    }

    .vouch-add {
      height: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #808695;

      &:hover .vouch-add-icon {
        border-color: @primary-color;
        color: @primary-color;
      }

      p {
        margin-top: 10px;
      }
    }

    .vouch-add-icon {
      width: 64px;
      height: 64px;
      border: 1px dashed #d9d9d9;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #808695;
      transition: all .2s;
    }

    .invoice-body {
      display: flex;
      position: relative;
      padding-bottom: 32px;
    }

    .invoice-block {
      flex: 1;
      padding: 8px 12px;
      border-radius: 4px;
      background: #f7f9fc;
      cursor: pointer;

      & + .invoice-block {
        margin-left: 12px;
      }

      &:hover {
        background: #eef4ff;
      }
    }

    .invoice-label {
      color: #515a6e;
      font-size: 13px;
    }

    .invoice-dot {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
    }

    .dot-out {
      background: #2db7f5;
    }

    .dot-in {
      background: #ff9900;
    }

    .invoice-amount {
      font-size: 20px;
      font-weight: bold;
      color: #17233d;
      margin: 6px 0;
    }

    .invoice-sub {
      font-size: 12px;
      color: #808695;
      line-height: 20px;
    }

    .invoice-empty {
      position: absolute;
      right: 16px;
      bottom: 10px;
      font-size: 12px;
      color: #c5c8ce;
    }

    .metric-item {
      padding: 12px 8px;
      text-align: center;
      background: #f7f9fc;
      border-radius: 4px;
      margin-bottom: 8px;
    }

    .metric-value {
      font-size: 18px;
      font-weight: bold;
      color: #17233d;
    }

    .metric-name {
      font-size: 12px;
      color: #808695;
      margin-top: 4px;
    }

    .side-list {
      min-height: 250px;
      padding: 8px 16px;
    }

    .notice-item,
    .memo-item {
      padding: 9px 0;
      border-bottom: 1px dashed #f0f0f0;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }
    }

    .notice-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .notice-title {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #515a6e;
      margin-right: 8px;

      &:hover {
        color: @primary-color;
      }
    }

    .notice-date {
      color: #c5c8ce;
      font-size: 12px;
      white-space: nowrap;
    }

    .memo-text {
      color: #515a6e;
      font-size: 13px;
      line-height: 20px;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .memo-date {
      color: #c5c8ce;
      font-size: 12px;
      margin-top: 4px;
    }

    .memo-panel .side-list {
      min-height: 180px;
    }

    .empty-tip {
      padding: 40px 0;
      text-align: center;
      color: #c5c8ce;
      font-size: 13px;
    }

    .notice-modal-list {
      max-height: 420px;
      overflow-y: auto;
    }

    .notice-modal-item {
      border-bottom: 1px solid #f0f0f0;
      padding: 10px 0;
    }

    .notice-modal-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      font-size: 14px;
    }

    .notice-modal-content {
      margin-top: 8px;
      padding: 10px 12px;
      background: #f7f9fc;
      border-radius: 4px;
      color: #515a6e;
      line-height: 22px;
      font-size: 13px;
      white-space: pre-wrap;
      word-break: break-all;
    }

    .memo-editor {
      textarea {
        width: 100%;
        resize: vertical;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        padding: 8px;
        font-size: 13px;
        color: #515a6e;
        outline: none;
      }
    }

    .memo-editor-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 8px;
    }

    .memo-list {
      margin-top: 16px;
      max-height: 300px;
      overflow-y: auto;
    }

    .memo-list-item {
      padding: 10px 0;
      border-bottom: 1px dashed #f0f0f0;
    }

    .memo-item-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 6px;
      font-size: 12px;

      a {
        margin-left: 10px;
      }
    }

    .memo-delete {
      cursor: pointer;
    }
  }
</style>
